import React from 'react';
import '../../../v2-theme.css';

/**
 * EmptyState Component
 *
 * Display when no data is available
 *
 * @param {string} message - Message to display
 * @param {string} icon - Optional icon or emoji to display
 * @param {React.ReactNode} children - Optional additional content
 */
const EmptyState = ({
  message = 'No items found',
  icon,
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`v2-empty-state ${className}`} {...props}>
      {icon && <div className="v2-empty-state-icon">{icon}</div>}
      <p className="v2-empty-state-message">{message}</p>
      {children}
    </div>
  );
};

export default EmptyState;
